<template>
  <div class="cpmponentS">
    <div class="cp_left">
      <img
        class="headerimg"
        src="@/assets/img/logo.png"
        alt="lost"
        title="新能智运平台"
      />
      <span style="font-size: 18px; margin-left: 10px;color: #2D3748;font-family: FZZhengHeiS-EB-GB; font-weight: 400;">新能智运平台</span>
      <!-- <span style="display: inline-block; width: 2px;height: 100%; background: #83E4C8;margin: 0 20px;"></span> -->
      <span class="fontsize" style="color: #838aa9">欢迎来到,新能智运平台~</span>
    </div>
    <div class="cp_right">
      <router-link to="/largescreen/index" style="color:blue;padding:0 20px;font-size:13px;">大屏首页</router-link>
      <img src="@/assets/homeImg/icon_xx_h.png" alt="" style="height: 20px;width: 20px;">
      <img src="@/assets/homeImg/icon_tc_d.png" alt="" @click="logout" style="height: 20px;width: 20px; margin-left: 20px;cursor: pointer;">
      <img src="@/assets/homeImg/mine_pic_head.png" alt="" style="height: 40px;width: 40px; margin-left: 20px;">
      <span class="fontsize" style="font-family: Source Han Sans CN;font-weight: 400;color: #2D3748;">欢迎您，{{usergt.username}}</span>
      <!-- <button class="btn" @click="logout">退出登录</button> -->
    </div>
  </div>
</template>
<script>
import mBadge from "@/components/mBadge.vue";
import {mapGetters,mapMutations} from "vuex"
export default {
  components: {
    mBadge,
  },
  computed:{
    ...mapGetters(["usergt"]),
  },
  methods: {
    ...mapMutations(["remove"]),
    async logout() {
      const { data } = await this.$http("api1", "/sys/logout", "post");
      if (data.code == 0) this.$message.success("退出登录成功");
      // window.sessionStorage.removeItem("itemindex");
      // window.sessionStorage.removeItem("routeindex");
      // window.sessionStorage.removeItem("user");
      // window.sessionStorage.removeItem("titleListNew");
      this.remove();
      this.$router.push("/login");
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.cpmponentS {
  height: 100%;
  width: 100%;
  // letter-spacing: 0.1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .cp_left {
    // float: left;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .headerimg {
      width: 32px;
      height: 32px;
      vertical-align: middle;
 
    }
  }
  .cp_right {
    // float: right;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    
  }
  .fontsize {
    font-size: 80%;
    margin-left: 10px;
  }
  
}
</style>